module.exports = __webpack_public_path__ + "img/footer_bg.e8d6c8a9.png";